import template from './shopping-center-scale-type.jade';
import items from '../../../enums/shopping-center-scale-type';

export default angular
    .module('cian.addForm.shoppingCenterScaleType', ['cian.addForm.fieldTypeDropdown'])
    .directive('cianAfAboutBuildingShoppingCenterScaleType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = items;
        },
        controllerAs: 'shoppingCenterScaleType',
        template,
    }))
    .name;
